import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import { useRegisterContext } from "../../Contexts/RegisterContext";
import { baseUrl } from "../../utilities/configurations";
import ErrorModal from "../../Components/ErrorModal";
import { useAuth } from "../../Contexts/AuthContext";
import { CircularProgress } from "@mui/material";
import OtpField from "../../Components/OtpField";
import Button from "../../Components/Button";
import { useState, useEffect } from "react";
import axios from "axios";
import dayjs from "dayjs";

function OTPVerifyCardDetails() {
  const {
    setDisplayAlert,
    setAlertMessage,
    alertMessage,
    displayAlert,
    isLoading,
    navigate,
    setEmail,
    setOtp,
    email,
    otp,
  } = useRegisterContext();

  const { setIsConnected, setUserData } = useAuth();

  useEffect(() => {
    const checkUser = async () => {
      try {
        await axios
          .get(baseUrl + `/policy/policies`, {
            withCredentials: true,
          })
          .then((response) => {
            setUserData(response.data.data);
            setIsConnected(true);
            navigate("/home");
          });
      } catch (error) {
        console.log(error);
      }
    };
    checkUser();
  }, []);

  const [counter, setCounter] = useState(180);

  useEffect(() => {
    const timer =
      counter > 0 &&
      setInterval(() => setCounter((prevCounter) => prevCounter - 1), 1000);
    return () => clearInterval(timer);
  }, [counter]);

  const formatTime = (seconds) =>
    dayjs().startOf("day").add(seconds, "seconds").format("mm:ss");

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setDisplayAlert(false);
  };

  const resendOtp = async () => {
    setCounter(180);

    const res = await axios.get("https://api.ipify.org/?format=json");
    const city = await axios.get(
      `https://ipapi.co/${JSON.stringify(res.data.ip).replaceAll(
        '"',
        ""
      )}/json/`
    );

    const sendOtp = async (response) => {
      try {
        await axios.post(
          baseUrl + "/otp/send-member-details-email-otp",
          {
            email: email,
            ipAddress: JSON.stringify(res.data.ip).split('"').join(""),
            location: JSON.stringify(city.data.city).split('"').join(""),
          },
          {
            headers: {
              Authorization: `Bearer ${response.data.data.accessToken}`,
            },
            hasCredentials: true,
          }
        );
      } catch (error) {
        console.log(error);
      }
    };

    try {
      await axios
        .post(
          baseUrl + "/connect-jwt",
          {
            username: process.env.REACT_APP_CONNECT_USERNAME,
            password: process.env.REACT_APP_CONNECT_PASSWORD,
          },
          {
            headers: { "content-type": "application/json" },
          }
        )
        .then((response) => {
          sendOtp(response);
        });
    } catch (error) {
      console.log(error);
    }
  };

  const handleVerify = async (e) => {
    const validateOTP = async (response) => {
      try {
        await axios
          .post(
            baseUrl + "/activate/send-member-details-email",
            {
              otp: otp,
            },
            {
              headers: {
                Authorization: `Bearer ${response.data.data.accessToken}`,
              },
            }
          )
          .then((response) => {
            if (response.data.status) {
              navigate("/activate/details-success");
              setOtp("");
            } else {
              setAlertMessage("Oops! Incorrect OTP. Please try again");
            }
          });
      } catch (error) {
        setDisplayAlert(true);
      }
    };

    try {
      await axios
        .post(
          baseUrl + "/connect-jwt",
          {
            username: process.env.REACT_APP_CONNECT_USERNAME,
            password: process.env.REACT_APP_CONNECT_PASSWORD,
          },
          {
            headers: { "content-type": "application/json" },
          }
        )
        .then((response) => {
          validateOTP(response);
        });
    } catch (error) {
      console.log(error);
    }
  };

  const handleOtpChange = (newOtp) => {
    setOtp(newOtp);
    setAlertMessage("");
  };

  const handleBack = () => {
    setEmail("");
    navigate("/activate/card-delivery");
  };
  const handleKeyDown = (event, callback) => {
    if (event.key === "Enter" || event.key === " ") {
      callback();
    }
  };
  return (
    <div className="flex flex-col min-h-screen max-w-screen sm:bg-[#E7EEFA] items-start sm:items-center cursor-default">
      <div className="flex flex-col w-full sm:w-148 sm:bg-white min-h-screen sm:min-h-0 items-start sm:items-center rounded-xl sm:mt-24 p-4">
        <div className="w-full grid grid-cols-1 divide-y">
          <div className="mb-4">
            <KeyboardArrowLeftIcon
              className="absolute cursor-pointer "
              onClick={handleBack}
            />
            <div className="text-center font-semibold text-[#1F2328]">
              Card Details Delivery
            </div>
          </div>

          <div>
            <div className="mt-3 text-xl font-semibold">
              Let's verify your email
            </div>
            <div className="flex flex-row mt-1">
              <div className=" text-[#60656D]">
                Verify your account by entering the one-time password sent to
                {/* */}
                <span className="text-[#1F2328] font-semibold ml-1">
                  {email.charAt(0) +
                    "*".repeat(email.indexOf("@") - 2) +
                    email.charAt(email.indexOf("@") - 1)}
                  {email.substr(email.indexOf("@"))}
                </span>
              </div>
            </div>

            <div className="mt-3">
              <OtpField
                value={otp}
                onChange={handleOtpChange}
                onSubmit={handleVerify}
                hasErrored={alertMessage}
              />
              <span className="text-sm text-[#D32F2F]">{alertMessage}</span>
            </div>
            <div className="flex flex-row mt-3">
              <div className="text-sm text-[#60656D]">
                Didn't get the password?{/* */}
                <button
                  className={`ml-1 ${
                    counter === 0 ? "cursor-pointer text-[#0947AB]" : null
                  }`}
                  onClick={counter === 0 ? resendOtp : null}
                  onKeyDown={(event) =>
                    handleKeyDown(event, () =>
                      counter === 0 ? resendOtp : null
                    )
                  }
                  tabIndex={0}
                >
                  {counter !== 0
                    ? `Resend (in ${formatTime(counter)})`
                    : "Resend OTP"}
                </button>
              </div>
            </div>
          </div>
        </div>
        <div className="bg-white flex-grow" />
        <div className="flex flex-col sm:items-end items-center w-full">
          <Button
            disabled={otp.length < 6 || isLoading}
            className={`w-full h-12 mt-2 ${
              otp.length < 6 || isLoading
                ? `text-[#A3A7AB] bg-[#F6F7F7]`
                : `text-white`
            }`}
            onClick={handleVerify}
          >
            {isLoading ? <CircularProgress size={"1rem"} /> : "Verify"}
          </Button>
        </div>
      </div>
      <ErrorModal
        open={displayAlert}
        title={"Uh-Oh! Mismatch detected"}
        message={
          "Oops! It seems there might be a hiccup. The information provided doesn't quite match what we have on record. Double-check the details and ensure accuracy to proceed seamlessly."
        }
        onClose={handleClose}
      />
    </div>
  );
}

export default OTPVerifyCardDetails;
